import { Button, Heading, Text } from "@instacover/ui"
import { createFileRoute } from "@tanstack/react-router"
import { useRef } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useTimeoutFn } from "react-use"

import { ExtraIcons } from "@/components/icons/InstructionImageType"
import { ImageLayout } from "@/components/layouts/ImageLayout"
import { useDispatchSDKEvent } from "@/helpers/sdk"
import { useSessionDetail } from "@/services/dexie"

export const Route = createFileRoute("/$sessionId/_session/finished")({
  component: FinishedPage,
})

function FinishedPage() {
  useDispatchSDKEvent("finished")

  const { t } = useTranslation()
  const { sessionId } = Route.useParams()
  const { data: detail } = useSessionDetail(sessionId)

  const redirectUrlOnSessionFinish = detail?.redirectUrlOnSessionFinish
  const redirectedRef = useRef(false)

  useTimeoutFn(async () => {
    if (!redirectUrlOnSessionFinish || redirectedRef.current) {
      return
    }

    window.location.href = redirectUrlOnSessionFinish
    redirectedRef.current = true
  }, 2000)

  return (
    <ImageLayout
      dataTestId="finished-page"
      baseLayoutProps={{ hideCounter: true }}
      iconName={ExtraIcons.Sent}
      content={
        <>
          <Heading as="h2" variant="h1" className="text-center">
            {t("finished.sent")}
          </Heading>

          <div className="h-6 w-6 shrink-0" />

          <Text as="p" className="text-left">
            <Trans i18nKey="finished.thankyou" />
          </Text>

          <div className="h-6 w-6 shrink-0" />

          {redirectUrlOnSessionFinish && (
            <Button as="a" href={redirectUrlOnSessionFinish} variant="primary" className="mb-6">
              {t("finished.close")}
            </Button>
          )}
        </>
      }
    />
  )
}
